import { packageVersion } from '@yonderland/andes-react';
export default () => packageVersion;
